var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:({
    content: _vm.htmlText,
    classes: 'tooltip',
    trigger: _vm.isMobile ? 'click' : 'hover',
}),expression:"{\n    content: htmlText,\n    classes: 'tooltip',\n    trigger: isMobile ? 'click' : 'hover',\n}",modifiers:{"top":true}}],staticClass:"info-icon-container"},[_c('img',{attrs:{"src":_vm.theme.tooltipSrcIcon,"alt":"information icon","width":"16px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }